/* eslint-disable i18next/no-literal-string */
import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import getEspaciosCasaCategories, {
    mapEspaciosCasaItems,
    type EspacioCasaItem
} from '@pylot-data/api/operations/get-espacios-casa-categories'
import type { CategoryTree, Maybe } from '@pylot-data/pylotschema'
import s from './EspaciosCasaMobilePanel.module.scss'

type EspaciosCasaMobilePanelProps = {
    title: string
    navChildren?: Maybe<Array<Maybe<CategoryTree>>> | null
    onBack: () => void
    onNavigate?: () => void
}

const EspaciosCasaMobilePanel = ({
    title,
    navChildren,
    onBack,
    onNavigate
}: EspaciosCasaMobilePanelProps): React.ReactElement => {
    const fallback = mapEspaciosCasaItems(navChildren, 'menu')
    const [items, setItems] = useState<EspacioCasaItem[]>(fallback)

    useEffect(() => {
        let cancelled = false
        getEspaciosCasaCategories({ imageKind: 'menu' })
            .then((data) => {
                if (!cancelled && data.length) setItems(data)
            })
            .catch(() => {
                /* fallback local */
            })
        return () => {
            cancelled = true
        }
    }, [])

    return (
        <div className={s.panel} role="dialog" aria-label={title}>
            <div className={s.intro}>
                <p className={s.eyebrow}>Inspírate</p>
                <p className={s.subtitle}>
                    Descubre ideas para cada espacio de tu hogar
                </p>
            </div>
            <div className={s.toolbar}>
                <button
                    type="button"
                    className={s.back}
                    onClick={onBack}
                >
                    {title}
                </button>
            </div>
            <div className={s.grid}>
                {items.map((item) => (
                    <Link
                        key={item.href + item.name}
                        href={item.href}
                        className={s.card}
                        onClick={onNavigate}
                    >
                        <span className={s.imageWrap}>
                            {item.image ? (
                                <img
                                    src={item.image}
                                    alt=""
                                    className={s.image}
                                />
                            ) : (
                                <span className={s.placeholder} />
                            )}
                            <span className={s.label}>{item.name}</span>
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default EspaciosCasaMobilePanel
